// DEPENDENCIES
import React from 'react'
import { render } from 'react-dom'
import { Router } from 'react-router-dom'

import history from 'utils/appHistory'

// COMPONENTS
import Main from 'components/Main'

// STYLES
import 'styles/main_global.scss'

// REDUX
import { applyMiddleware, createStore, compose, combineReducers } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import alarmReducer from 'store/reducers/alarmReducer'
import authReducer from 'store/reducers/authReducer'
import downloadReducer from 'store/reducers/downloadReducer'
import historyReducer from 'store/reducers/historyReducer'
import playerReducer from 'store/reducers/playerReducer'

// If in dev mode, load redux dev tools chrome extension
const composeEnhancers =
  process.env.NODE_ENV === 'production'
    ? compose
    : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const rootReducer = combineReducers({
  alarm: alarmReducer,
  auth: authReducer,
  download: downloadReducer,
  history: historyReducer,
  player: playerReducer,
})

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)))

const renderReactDOM = () =>
  render(
    <Provider store={store}>
      <Router history={history}>
        <Main />
      </Router>
    </Provider>,
    document.getElementById('root')
  )

if (!window.cordova) renderReactDOM()
else
  document.addEventListener(
    'deviceready',
    () => {
      if (window.cordova.platformId == 'android')
        window.StatusBar.backgroundColorByHexString('#3676b6')

      renderReactDOM()
    },
    false
  )
